import React from 'react';
import { styled } from "@mui/material/styles";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Image from '../../Utils/getImage';
import Grid from "@mui/material/Grid2";



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));


const Addcatalogue = ({ openviewDialog, setopenviewDialog, selectedCategory, mode, selectedsubCategory }) => {
    const title = mode === "category" ? "Add your category to the list" : "Add your category to the list";
    //handle close
    const handleClose = () => {
        setopenviewDialog(false);
    };

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openviewDialog}
                className="view-catalogue"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    {mode === "category" ? `view  ${mode} Details` : `view ${mode} Details`}
                    <Typography>{title}</Typography>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    {mode === 'category' ?
                        (
                            <section className='view-catalogue-content'>
                                <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                                        <div className='view-catalogue-image'>
                                            <Image src={selectedCategory?.Bannerimage} alt="Bannerimage" width={190} height={190} />
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                                        <div className='view-catalogue-right'>
                                            <div className='view-catalogue-text'>
                                                <Typography variant='h5'>Category Name</Typography>
                                                <Typography>{selectedCategory?.category ? selectedCategory?.category : "---"}</Typography>
                                            </div>
                                            <div className='view-catalogue-text'>
                                                <Typography variant='h5'>created Date</Typography>
                                                <Typography>
                                                    {selectedCategory?.createddDate
                                                        ? selectedCategory?.createddDate
                                                        : "---"}
                                                </Typography>
                                            </div>
                                            <div className='view-catalogue-text'>
                                                <Typography variant='h5'>Upload date</Typography>
                                                <Typography>
                                                    {selectedCategory?.UpdatedDate
                                                        ? selectedCategory?.UpdatedDate
                                                        : "---"}
                                                </Typography>
                                            </div>
                                        </div>
                                        <div className='view-catalogue-right' style={{ marginTop: 20 }}>
                                            <div className='view-catalogue-text'>
                                                <Typography variant='h5'>Status</Typography>
                                                <label class="switch">
                                                    <input type="checkbox" checked={selectedCategory?.status} readOnly />
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </section>
                        ) : (
                            <section className='view-catalogue-content'>
                                <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                                        <div className='view-catalogue-image'>
                                            <Image src={selectedsubCategory?.Bannerimage} alt="Bannerimage" width={190} height={190} />
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                                        <div className='view-catalogue-right'>
                                            <div className='view-catalogue-text'>
                                                <Typography variant='h5'>Category Name</Typography>
                                                <Typography>{selectedsubCategory?.subCategory ? selectedsubCategory?.subCategory : "---"}</Typography>
                                            </div>
                                            <div className='view-catalogue-text'>
                                                <Typography variant='h5'>created Date</Typography>
                                                <Typography>
                                                    {selectedsubCategory?.createddDate
                                                        ? selectedsubCategory?.createddDate
                                                        : "---"}
                                                </Typography>
                                            </div>
                                            <div className='view-catalogue-text'>
                                                <Typography variant='h5'>Upload date</Typography>
                                                <Typography>
                                                    {selectedsubCategory?.UpdatedDate ? selectedsubCategory?.UpdatedDate : "---"}
                                                </Typography>
                                            </div>
                                        </div>
                                        <div className='view-catalogue-right' style={{ marginTop: 20 }}>
                                            <div className='view-catalogue-text'>
                                                <Typography variant='h5'>Status</Typography>
                                                <label class="switch">
                                                    <input type="checkbox" checked={selectedsubCategory?.status} readOnly />
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </section>
                        )
                    }
                </DialogContent>
                <DialogActions>
                    <Button
                        className="cancel-btn"
                        onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default Addcatalogue;